import React, { memo, useState } from 'react'
import DeleteIcon from 'transfix-icons/build/DeleteIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { IVin } from 'types/carrier'
import { DeleteScheduleVinModal } from './DeleteScheduleVin'

interface ISingleVinProps {
  vin: IVin
  deleteVin?: (vin: IVin) => void
}

export const DeleteSingleVin = memo<ISingleVinProps>(({ deleteVin, vin }) => {
  const [isDeleteScheduleVinModalOpen, setIsDeleteScheduleVinModalOpen] = useState<boolean>(false)
  const { vin: label } = vin
  const isDeleteVinEnabled = !!deleteVin

  const openModalHandler = () => {
    setIsDeleteScheduleVinModalOpen(true)
  }

  const closeModalHandler = () => {
    setIsDeleteScheduleVinModalOpen(false)
  }

  const handleDelete = () => {
    deleteVin!(vin)
    closeModalHandler()
  }
  return (
    <>
      <div data-test={`${label}-id`}>
        <span className='ph1'>{label}</span>
        {isDeleteVinEnabled && (
          <IconButton
            Icon={DeleteIcon}
            color='tertiary'
            onClick={openModalHandler}
            data-test='delete-vin-button'
            label='Delete VIN'
            size='large'
          />
        )}
      </div>
      <DeleteScheduleVinModal
        open={isDeleteScheduleVinModalOpen}
        onConfirm={handleDelete}
        onCancel={closeModalHandler}
        onClose={closeModalHandler}
      />
    </>
  )
})
